import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";

import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";

import img_team_1 from "./images/team/img_team_1";
import img_team_2 from "./images/team/img_team_2";
import img_team_3 from "./images/team/img_team_3";

import tata from "./images/company/tata";
import pagariya from "./images/company/pagariya";
import usha from "./images/company/usha";
import trenz from "./images/company/trenz";
import money_roots from "./images/company/money_roots";
import mahindra from "./images/company/mahindra";
import decor_1 from "./images/decor_1";

import mutha from "../assets/img/mutha.jpeg";
import shree from "../assets/img/shree.jpeg";
import logo_shree from "./images/company/logo_shree.png";
import logo_shankh from "./images/company/logo_shankh.jpg";
import logo_deep from "./images/company/logo_deep.jpg";
import guddi_logo from "./images/company/guddi_logo";
import varad from "../assets/img/varadinfra.jpeg";
import rpdaga from "../assets/img/rpdaga.jpeg";
import naresh from "../assets/img/naresh.jpeg";
import saisuvidha from "../assets/img/saisuvidha.jpeg";
import plus from "../assets/img/plus.jpeg";
import hridayam from "../assets/img/hridayam.jpeg";
import wealth from "../assets/img/wealth.jpeg";

import colorSharp2 from "../assets/img/color-sharp2.png";
// import 'animate.css';
import "../App.css";
import TrackVisibility from "react-on-screen";
import { Link } from "react-router-dom";

export const Projects = () => {
  const projects = [
    {
      title: "Shree Jewellers",
      description:"A Jewellery Shop in Parbhani  serves a best collection for his Customers",
      imgUrl: shree,
      URL: "https://shreejewellerspbn.com/",
    },
    {
      title: "Hridayam Healthcare Center",
      description: "Best Heart care Hospital in Maharashtra",
      imgUrl: hridayam,
      url: "https://hridayamheartcarecenter.com/",
    },
    {
      title: "Mutha Motors",
      description: "",
      imgUrl: mutha,
      link: "http://muthamotors.com/",
    },
    {
      title: "varad Infra",
      description: "Design & Development",
      imgUrl: varad,
    },
    {
      title: "Plus Healthcare Solutions",
      description: "Design & Development",
      imgUrl: plus,
    },
    {
      title: "Wealth Creationn",
      description: "Design & Development",
      imgUrl: wealth,
    },
    {
      title: "RP DAGA",
      description: "Design & Development",
      imgUrl: rpdaga,
    },
    {
      title: "Naresh Sharma Photography",
      description: "Design & Development",
      imgUrl: naresh,
    },
    {
      title: "Sai Suvidha",
      description: "Design & Development",
      imgUrl: saisuvidha,
    },
  ];
  const project2 = [
    {
      title: "Shree Jewellers",
      description:"A Jewellery Shop in Parbhani  serves a best collection for his Customers",
      imgUrl: logo_shree,
    },
    {
      title: "Shanckh ",
      description:"An Ethnic Thread",
      imgUrl: logo_shankh,
    },
    {
      title: "Deep Traders ",
      description:"one of the leading businesses in the Spice Retailers.",
      imgUrl: logo_deep,
    },
    {
      title: "Guddy Gold ",
      description:"Swaad Ek Behatar Kal ka",
      imgUrl: guddi_logo,
    },
  ];

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Projects</h2>
                  <p>
                    We at Top Notch Media Works help you design your own website
                    of all the types ranging from small to medium businesses,
                    also including e-commerce website. Web designing is the art
                    of creation of various websites or pages which helps to
                    represent a company’s brand, services or information which
                    also ensures a user-friendly experience. A website is a
                    collection of web pages which is accessible to the public on
                    internet.
                  </p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav
                      variant="pills"
                      className="nav-pills mb-5 justify-content-center align-items-center"
                      id="pills-tab"
                    >
                      <Nav.Item>
                        <Nav.Link eventKey="first">Websites</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Ongoing Work</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">Company Activity</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content
                      id="slideInUp"
                      className={
                        isVisible ? "animate__animated animate__slideInUp" : ""
                      }
                    >
                      <Tab.Pane eventKey="first">
                        <Row>
                          {projects.map((project, index) => {
                            return <ProjectCard key={index} {...project} />
                          })}
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <Row>
                          {project2.map((projectsecond, item) => {
                            return (
                              <ProjectCard key={item} {...projectsecond} />
                            )
                          })}
                          {/* <Link to="/about" className="eg-btn btn--primary btn--lg btn-center">
                      Know More
                    </Link>  */}
                        </Row>
                        {/* <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p> */}
                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <section
                          className="elementor-section elementor-top-section elementor-element elementor-element-f87a0f2 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                          data-id="f87a0f2"
                          data-element_type="section"
                          data-settings='{"background_background":"classic"}'
                        >
                          <div className="elementor-container elementor-column-gap-default">
                            <div
                              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-8fb7747"
                              data-id="8fb7747"
                              data-element_type="column"
                            >
                              <div className="elementor-widget-wrap elementor-element-populated">
                                <section
                                  className="elementor-section elementor-inner-section elementor-element elementor-element-52b8137 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                  data-id="52b8137"
                                  data-element_type="section"
                                >
                                  <div className="elementor-container elementor-column-gap-no">
                                    <div
                                      className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-b38ae14"
                                      data-id="b38ae14"
                                      data-element_type="column"
                                    >
                                      <div className="elementor-widget-wrap"></div>
                                    </div>
                                    <div
                                      className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-f809acf"
                                      data-id="f809acf"
                                      data-element_type="column"
                                    >
                                      <div className="elementor-widget-wrap elementor-element-populated">
                                        <div
                                          className="elementor-element elementor-element-220ecd7 elementor-widget elementor-widget-spinner_heading"
                                          data-id="220ecd7"
                                          data-element_type="widget"
                                          data-widget_type="spinner_heading.default"
                                        >
                                          <div className="elementor-widget-container">
                                            <div className="section-title  primary4 position-relative">
                                              <span>-Our Video-</span>
                                              <h3 className="text-light">
                                                Our Company Activities
                                              </h3>
                                              {/* <p className="para mb-0">
                              Get the most of reduction in your teams operating
                              costs for the whole product which creates amazing
                              UI/UX experiences.
                            </p> */}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-a03eba8"
                                      data-id="a03eba8"
                                      data-element_type="column"
                                    >
                                      <div className="elementor-widget-wrap"></div>
                                    </div>
                                  </div>
                                </section>
                                <div
                                  className="elementor-element elementor-element-aa8992a elementor-widget elementor-widget-spinner_activites"
                                  data-id="aa8992a"
                                  data-element_type="widget"
                                  data-widget_type="spinner_activites.default"
                                >
                                  <div className="elementor-widget-container">
                                    <div className="row justify-content-center">
                                      <div className="activities-area">
                                        <div
                                          className="company-vdo position-relative wow fadeInDown"
                                          data-wow-duration="1.5s"
                                          data-wow-delay="0.2s"
                                        >
                                          <div className="video-play style-2">
                                            <a
                                              href="https://www.instagram.com/topnotch_mediaworks/?igshid=1hjl2cpdo05gq"
                                              className="popup-youtube video-icon"
                                            >
                                              <i className="bi bi-play-circle-fill"></i>
                                            </a>
                                          </div>
                                        </div>
                                        <div
                                          className="company-counter wow fadeInUp"
                                          data-wow-duration="1.5s"
                                          data-wow-delay="0.2s"
                                        >
                                          <div className="row g-4 d-flex justify-content-center">
                                            <div className="col-lg-3 col-md-6 col-sm-10 col-10">
                                              <div
                                                className="counter-single text-center d-flex flex-row wow animate fadeInDown"
                                                data-wow-duration="1.5s"
                                                data-wow-delay="0.6s"
                                              >
                                                <div className="coundown  flex-column d-flex align-items-center">
                                                  <div className="counter-number d-flex align-items-center flex-row">
                                                    <h2
                                                      className="odometer"
                                                      data-odometer-final="100"
                                                    >
                                                      &nbsp;
                                                    </h2>
                                                    <span className="plus-icon">
                                                      128 +
                                                    </span>
                                                  </div>
                                                  <a href="#">
                                                    Happy Customer{" "}
                                                  </a>
                                                </div>
                                              </div>
                                            </div>

                                            <div className="col-lg-3 col-md-6 col-sm-10 col-10">
                                              <div
                                                className="counter-single text-center d-flex flex-row wow animate fadeInDown"
                                                data-wow-duration="1.5s"
                                                data-wow-delay="0.6s"
                                              >
                                                <div className="coundown  flex-column d-flex align-items-center">
                                                  <div className="counter-number d-flex align-items-center flex-row">
                                                    <h2
                                                      className="odometer"
                                                      data-odometer-final="150"
                                                    >
                                                      &nbsp;
                                                    </h2>
                                                    <span className="plus-icon">
                                                      90+
                                                    </span>
                                                  </div>
                                                  <a href="#">Happy Clients </a>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6 col-sm-10 col-10">
                                              <div
                                                className="counter-single text-center d-flex flex-row wow animate fadeInDown"
                                                data-wow-duration="1.5s"
                                                data-wow-delay="0.6s"
                                              >
                                                <div className="coundown  flex-column d-flex align-items-center">
                                                  <div className="counter-number d-flex align-items-center flex-row">
                                                    <h2
                                                      className="odometer"
                                                      data-odometer-final="130"
                                                    >
                                                      &nbsp;
                                                    </h2>
                                                    <span className="plus-icon">
                                                      1,030 +
                                                    </span>
                                                  </div>
                                                  <a href="#">cups of coffee</a>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                        {/* <p>Top notch media works is one of the best branding
agencies in Maharashtra. We provide best and
innovative solutions with strong strategy and
creative ideas as well as overcome the business
challenges in a right way that would give your
business a way to step a higher level. We provide
services such as web designing, strategic planning,
staff and owner training, digital media, print media
etc. that would make your business add an extra
amount of profitability in the industry.</p>


<Link to="/about" className="eg-btn btn--primary btn--lg btn-center">
                      Know More
                    </Link> */}
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  );
};
